import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './BottomNav.css';

const tabs = [
  { to: '/today',     label: 'Hoy',        icon: '🏋️' },
  { to: '/exercises', label: 'Ejercicios', icon: '💪' },
  { to: '/routines',  label: 'Rutinas',    icon: '📅' },
  { to: '/history',   label: 'Historial',  icon: '📊' },
  { to: '/profile',   label: 'Perfil',     icon: '👤' },
];

const adminTab = { to: '/admin', label: 'Admin', icon: '⚙️' };

export default function BottomNav() {
  const { user } = useAuth();
  const navTabs = user?.is_admin ? [...tabs, adminTab] : tabs;

  return (
    <nav className="bottom-nav">
      {navTabs.map(({ to, label, icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) => 'bottom-nav-tab' + (isActive ? ' active' : '')}
        >
          <span className="bottom-nav-icon">{icon}</span>
          <span className="bottom-nav-label">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
